import { Component } from '@angular/core';
import { PituploadNavComponent } from 'src/app/global-composants/pitupload-nav/pitupload-nav.component';
import { Ope } from 'src/app/models/Ope';
import { DocServices } from 'src/app/services/docs/docs.services';
import { OptionServices } from 'src/app/services/options/option.service';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { PituploadProgrammePresentationComponent } from './pitupload-programme-presentation/pitupload-programme-presentation.component';
import { PituploadGalerieComponent } from './pitupload-galerie/pitupload-galerie.component';
import { PituploadDocListComponent } from './pitupload-doc-list/pitupload-doc-list.component';
import { PituploadPlansPublicationComponent } from './pitupload-plans-publication/pitupload-plans-publication.component';
import { PituploadEspacesVenteComponent } from './pitupload-espaces-vente/pitupload-espaces-vente.component';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-programme-pitupload',
  templateUrl: './page-programme-pitupload.component.html',
  imports: [PituploadNavComponent,PituploadProgrammePresentationComponent,PituploadGalerieComponent,PituploadDocListComponent,PituploadPlansPublicationComponent,PituploadEspacesVenteComponent,ToastModule,CommonModule],
  styleUrls: ['./page-programme-pitupload.component.scss']
})
export class PageProgrammePituploadComponent {
  programme!: Ope | null;

  constructor(
    public share: shareOpeSevices,
    private readonly docsndVigneteService: DocServices,
    private readonly optionService: OptionServices,
    public sharePitSevices: sharePitSevices
  ) { }

  ngOnInit() {


  }

}